import PropTypes from "prop-types"
import { MenuItem } from "@mui/material"
import { Info } from "@mui/icons-material"
import OPTooltip from "components/material/tooltip"

export default function ItemHeaderMenuItem({ fn, label, disabled, disabledTooltip }) {
  let item = <MenuItem disabled={disabled} onClick={fn} data-test-class="comparison-item-menu-option">{label}</MenuItem>

  if (disabled && disabledTooltip) {
    item = <OPTooltip
      title={disabledTooltip}
    >
      <div className="disabled-menuItem-tooltip">
        {item}
        <Info />
      </div>
    </OPTooltip>
  }

  return item
}

ItemHeaderMenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  fn: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  disabledTooltip: PropTypes.string,
}
